module.exports = __webpack_public_path__ + "static/media/visa.56b85866.svg";